import React, { useState } from 'react';

const defaultValue = {
  compras: [],
  compraAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  filtroAvancado: {},
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: 'dataCompra,DESC',
};

export const CompraContext = React.createContext({});

export const CompraProvider = (props) => {
  return (
    <CompraContext.Provider
      value={{
        compras: useState(defaultValue.compras),
        compraAtual: useState(defaultValue.compraAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        filtroAvancado: useState(defaultValue.filtroAvancado),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </CompraContext.Provider>
  );
};

export const CompraConsumer = CompraContext.Consumer;
